import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";

export default {
    async getAll() {
        const res = await http.get(buildUrlFromLocation("/campaigns/list"));
        return res.data.map(mapCampaign);
    },
    async update({ id, campaign }) {
        return await http.put(buildUrlFromLocation(`/admin/campaigns/${id}`), campaign);
    },
    async deleteCampaign(id) {
        return await http.delete(buildUrlFromLocation(`/admin/campaigns/${id}`));
    }
};

function mapCampaign({ Campaign_UTC_End, Campaign_UTC_start, active, createdAt, createdBy, endDate, id, name, lastCampaign, shortName }) {
    return {
        active,
        createdAt,
        createdBy,
        id,
        launchDate: Campaign_UTC_start,
        endDate: Campaign_UTC_End,
        lastCampaign,
        name,
        shortName
    };
}



// WEBPACK FOOTER //
// ./src/services/campaign.js